import api from './api';

const fetchEventsByType = ({commit, state}, type) => {
    if (state.events[type].length) return;

    let filter = type
    if (filter === 'summit') {
        filter = 'summit,sps';
    }

    return new Promise((resolve, reject) => {
        api.fetchEvents(filter)
            .then(events => {
                commit('SET_EVENTS', {type, events});
                resolve(events);
            })
            .catch(({response}) => reject(response));
    });
};

const generateInvoice = ({commit}, payload) => {
    commit('SET_ERROR', {});
    
    return new Promise((resolve, reject) => {
        api.generateInvoice(payload)
            .then(({data}) => {
                resolve(data.signed_url);
            })
            .catch(data => {
                commit('SET_ERROR', data);
                reject(data);
            });
    });
};

const generateCertificate = ({commit}, payload) => {
    commit('SET_ERROR', {});

    return new Promise((resolve, reject) => {
        api.generateCertificate(payload)
            .then(({data}) => {
                resolve(data.signed_url);
            })
            .catch(data => {
                commit('SET_ERROR', data);
                reject(data);
            });
    });
};

export default {
    fetchEventsByType,
    generateInvoice,
    generateCertificate
}